export enum NotificationTypes {

    Error = 'error',
    Info = 'info',
    Success = 'success',
    Warning = 'warning'

};